<template>
  <b-modal
    id="modal-workplace-contract-effective-date"
    ref="contractEffectiveDateModal"
    :title="workplaceContractEffectiveDate.workplace_name ? `Alterar vigência do contrato (${workplaceContractEffectiveDate.workplace_name})` : ''"
    hide-footer
    centered
  >
    <div>
      <p>Informe a data</p>
      <div class="d-flex">
        <b-form-datepicker
          id="request-enabled-at"
          v-model="workplaceContractEffectiveDate.contract_effective_date"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          locale="pt-BR"
          label-help=""
          label-no-date-selected="Selecione"
        />
        <b-button
          variant="primary"
          class="ml-1 w-100"
          :disabled="loading"
          @click="editContractEffectiveDate"
        >
          <span class="d-none d-sm-inline">Alterar</span>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton, BFormDatepicker, BModal, VBModal,
} from 'bootstrap-vue'
import useWorkplaceContractEffectiveDate from './useWorkplaceContractEffectiveDate'

export default {
  components: {
    BButton,
    BFormDatepicker,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup(_, { emit }) {
    const {
      loading,
      contractEffectiveDateModal,
      workplaceContractEffectiveDate,
      show,
      editContractEffectiveDate,
    } = useWorkplaceContractEffectiveDate(() => emit('refetch-data'))

    return {
      loading,
      contractEffectiveDateModal,
      workplaceContractEffectiveDate,
      show,
      editContractEffectiveDate,
    }
  },
}
</script>
